import { Optional } from 'functions/promiseExtensions';
import * as UnitLight from 'types/Unit/UnitLight';

export type Type = {
	selectedUnit: number;
	weight: number;
	isLoadingAi: boolean;
};

export function create(): Type {
	return {
		selectedUnit: 0,
		weight: 0,
		isLoadingAi: false,
	};
}

export function setWeight(state: Type, input: number): Type {
	return { ...state, weight: input };
}

export function setSelectedUnit(state: Type, input: number): Type {
	return { ...state, selectedUnit: input };
}

export function setIsLoadingAi(state: Type, input: boolean): Type {
	return { ...state, isLoadingAi: input };
}

export function resetValues(state: Type): Type {
	return { ...state, weight: 0, selectedUnit: 0 };
}

export async function getSuggestedUnitWeight(
	state: Type,
	input:
		| {
				callback: (value: UnitLight.Type) => Promise<Optional<number>>;
				selectedUnit: UnitLight.Type;
		  }
		| undefined
): Promise<Type> {
	if (!input) return state;
	const suggestedWeight = await input.callback(input.selectedUnit);

	return { ...state, weight: suggestedWeight.getOrDefault(0), isLoadingAi: false };
}
